// Payment success page - handles successful Stripe payments
import { createElement } from '@/utils/dom'
import { router } from '@/utils/router'
import { stripeService } from '@/services/stripe'
import { authService } from '@/services/auth'

export class PaymentSuccessPage {
  async render(): Promise<HTMLElement> {
    const page = createElement('div', { className: 'payment-success-page' })

    // Get subscription context from localStorage
    const context = stripeService.getAndClearSubscriptionContext()
    const planName = context?.planName || 'Solo'

    page.innerHTML = `
      <div class="payment-container">
        <div class="success-card">
          <div class="success-icon">
            <i class="fas fa-check-circle"></i>
          </div>
          
          <h1>Pagamento Confirmado!</h1>
          <p class="success-message">
          Obrigado pela sua subscrição do plano <strong>${planName}</strong>.
          A sua faturação mensal foi processada com sucesso.
          </p>

          <div class="success-details">
            <div class="detail-item">
              <i class="fas fa-shield-alt"></i>
              <span>Pagamento seguro processado</span>
            </div>
            
            <div class="detail-item">
              <i class="fas fa-rocket"></i>
              <span>Acesso imediato ao dashboard</span>
            </div>
          </div>

          <div class="success-actions">
            <button class="btn btn-primary btn-lg" id="go-dashboard">
              <i class="fas fa-tachometer-alt"></i>
              Aceder ao Dashboard
            </button>
            
            <button class="btn btn-outline btn-lg" id="go-home">
              Voltar ao Início
            </button>
          </div>

          <div class="support-info">
            <p>Precisa de ajuda? <a href="mailto:geral@mapakms.com">geral@mapakms.com</a></p>
          </div>
        </div>
      </div>
    `

    // Add navigation handlers
    const dashboardBtn = page.querySelector('#go-dashboard') as HTMLButtonElement
    const homeBtn = page.querySelector('#go-home') as HTMLButtonElement

    dashboardBtn.addEventListener('click', async () => {
      // Refresh user data to get updated subscription status
      try {
        dashboardBtn.disabled = true
        dashboardBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Atualizando...'

        // Fetch updated user data from backend
        await authService.refreshUserData()

        // Navigate to dashboard with fresh subscription data
        router.navigate('/dashboard')
      } catch (error) {
        console.error('Failed to refresh user data:', error)
        // Navigate anyway - user can refresh dashboard manually
        router.navigate('/dashboard')
      }
    })

    homeBtn.addEventListener('click', () => {
      router.navigate('/')
    })

    return page
  }
}
